import React from "react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div data-testid="login-page" className="min-h-screen bg-ink text-white grid place-items-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="text-mono text-xs uppercase tracking-[0.4em] text-adrenaline">Admin Access</div>
        <h1 className="text-display text-6xl uppercase leading-none mt-3">Sign In</h1>
        <p className="text-zinc-400 mt-6">Sign in with Google. Only allow-listed emails see the admin dashboard.</p>
        <button data-testid="google-login-btn" onClick={handleLogin} className="mt-10 w-full py-4 bg-white text-black text-heading uppercase tracking-[0.2em] text-sm hover:bg-adrenaline hover:text-white transition-colors flex items-center justify-center gap-3">
          <span className="text-mono">G</span> Continue with Google
        </button>
        <p className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600 mt-8">By signing in you agree to our terms & privacy policy.</p>
      </div>
    </div>
  );
}
